import React from 'react';

interface BuilderProgressBarProps {
  focusedSlot: string;
  slotSequence: string[];
  onSlotChange: (slot: string) => void;
}

const BuilderProgressBar: React.FC<BuilderProgressBarProps> = ({
  focusedSlot,
  slotSequence,
  onSlotChange,
}) => {
  return (
    <div className="flex flex-1 justify-end">
      <nav
        className="flex gap-1 my-auto rounded-xl overflow-hidden
          max-md:flex-1 max-md:flex-wrap
        "
      >
        {slotSequence.map((slot, i) => (
          <ProgressBarStep
            key={i}
            slot={slot}
            status={
              i < slotSequence.indexOf(focusedSlot)
                ? 'completed'
                : i === slotSequence.indexOf(focusedSlot)
                  ? 'active'
                  : 'pending'
            }
            onClick={() => {
              onSlotChange(slot);
            }}
          />
        ))}
      </nav>
    </div>
  );

  function ProgressBarStep({
    slot,
    status,
    onClick,
  }: {
    slot: string;
    status: 'pending' | 'active' | 'completed';
    onClick: () => void;
  }) {
    return (
      <div
        className={`h-5 cursor-pointer w-28
            max-md:w-auto max-md:flex-1 
          ${
            status === 'completed'
              ? 'bg-blue-600'
              : status === 'active'
                ? 'bg-blue-600'
                : 'bg-gray-200'
          }`}
        onClick={onClick}
      />
    );
  }
};

export default BuilderProgressBar;
